import {
  buildCropAzureOutput,
  buildPhotoAzureOutput,
  buildTimingsAzurePartial,
  INSTALLATION_MODE_INTERVAL_MINUTES,
  mergeAzureConfig,
} from "./installationConfigUtils";

import { SCHEDULE_MODE_PRODUCTION } from "./installationScheduleModeUtils";

const DEFAULT_IMAGE_READINGS_PRODUCTION_CRON = "0,30 8-18 * * *";

const DEFAULT_IMAGE_READINGS_PRODUCTION_TIMINGS = [
  DEFAULT_IMAGE_READINGS_PRODUCTION_CRON,
];

export const DEFAULT_IMAGE_READINGS_ROTATION_ANGLE = 0;

export function buildDefaultImageReadingsCronState() {
  return {
    scheduleMode: SCHEDULE_MODE_PRODUCTION,
    intervalMinutes: INSTALLATION_MODE_INTERVAL_MINUTES,
    activeTimings: [...DEFAULT_IMAGE_READINGS_PRODUCTION_TIMINGS],
    timingsSave: [...DEFAULT_IMAGE_READINGS_PRODUCTION_TIMINGS],
  };
}

export function buildDefaultImageReadingsAzureOutput(configData) {
  const timingsPartial = buildTimingsAzurePartial(
    configData,
    DEFAULT_IMAGE_READINGS_PRODUCTION_TIMINGS,
    DEFAULT_IMAGE_READINGS_PRODUCTION_TIMINGS,
  );

  let output = mergeAzureConfig(configData, timingsPartial);
  output = buildPhotoAzureOutput(output, "left", true);
  output = buildPhotoAzureOutput(output, "right", true);
  output = buildCropAzureOutput(output, "left", []);
  output = buildCropAzureOutput(output, "right", []);
  output = {
    ...output,
    hdr: 0,
    sspd_ref_coefficient_list: [1.0],
  };

  return output;
}
